import React, { useState } from "react";
import ActualizarPreciosExcel from "./actualizarPreciosExcel";
import IncluirProductosExcel from "./incluirProductosExcel";
import FileExcelClientes from "./archivosExcelCliente";

const fileExcel = () => {
  const [pantalla, setPantalla] = useState(1);
  const cambiarpantalla = (p) => {
    setPantalla(p);
  };

  const PANTALLAS = {
    1: <ActualizarPreciosExcel />,
    2: <IncluirProductosExcel />,
    3: <FileExcelClientes />,
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-11 mx-auto py-2 card shadow">
            <div className="col-md-12 row border-azul mx-auto rounded py-1">
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                <div className="col-md-4">
                  <h3>Actualización por Archivo XLSX</h3>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>
              <div className="col-md-6 row mt-3 d-flex  justify-content-between">
                <button
                  onClick={() => cambiarpantalla(1)}
                  className="btn btn-sm btn-info col"
                >
                  <i className="fas fa-check-circle"> Actualizar Precios</i>
                </button>
                <button
                  onClick={() => cambiarpantalla(2)}
                  className="btn btn-sm btn-primary col"
                >
                  <i className="fas fa-check-circle"> Incluir Productos</i>
                </button>
                <button
                  onClick={() => cambiarpantalla(3)}
                  className="btn btn-sm btn-secondary col"
                >
                  <i className="fas fa-check-circle"> Incluir Clientes</i>
                </button>
              </div>
              {PANTALLAS[pantalla]}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default fileExcel;



// WEBPACK FOOTER //
// ./src/components/almacen/archivosExcel.js